import { Modules, WidgetModules } from 'core/widgets-types';
export let MODULE = Modules[WidgetModules.None];

export function setCurrentModule() {
  const _module = window.location.pathname.split('/')[1] as WidgetModules;
  if (Modules[_module]) MODULE = Modules[_module];
}
